import type { MFAttestationSummary } from "state/members/accessReviews";

type WithReviewType = Pick<MFAttestationSummary, "reviewType">;

export const isOwnerSignOff = (att: WithReviewType): boolean =>
  att.reviewType === "attestation_only";

/**
 * Entitlement-only cycles (PLO-5731): every reviewable row is ONE entitlement
 * of one account, so a person holding three roles is three rows and a removal
 * decision takes away only the row's own entitlement. The single chokepoint for
 * that mode — the campaign card, the review table, the decision dialog and the
 * account drawer all ask here rather than comparing the string themselves.
 *
 * Accepts a nullish subject so callers reading an optional cycle snapshot can
 * pass it straight through; nothing known about the cycle means "standard".
 */
export const isEntitlementOnly = (
  subject: WithReviewType | null | undefined,
): boolean => subject?.reviewType === "entitlement_only";

/**
 * Combined reviews: one review for a campaign's whole scope, its rows about
 * many resources. Nullish means a standard per-resource review.
 */
export const isCombinedReview = (
  cycle: { combineReviews?: boolean } | null | undefined,
): boolean => cycle?.combineReviews === true;

export const signOffCtaLabel = (att: WithReviewType): "Attest" | "Review and attest" =>
  isOwnerSignOff(att) ? "Attest" : "Review and attest";
